import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import { Guitar, Mic2, Radio, Globe2, ShieldCheck } from "lucide-react";

const CARDS = [
  {
    id: "instruments",
    icon: Guitar,
    accent: "text-hpink",
    glow: "group-hover:border-hpink/40",
    title: "Instruments",
    items: ["Acoustic Rhythm Guitar — Self-Accompaniment"],
  },
  {
    id: "vocal-strengths",
    icon: Mic2,
    accent: "text-horange",
    glow: "group-hover:border-horange/40",
    title: "Vocal Strengths",
    items: ["Lead belt", "Harmony stacking", "Blend", "Improvisation", "Vocal arranging", "Quick ear memorization"],
  },
  {
    id: "stage-technical",
    icon: Radio,
    accent: "text-hblue",
    glow: "group-hover:border-hblue/40",
    title: "Stage & Technical",
    items: ["Live crowd interaction", "Dynamic set pacing", "Wireless handheld & headset mic technique", "Stage presence"],
  },
  {
    id: "logistics",
    icon: Globe2,
    accent: "text-hpink",
    glow: "group-hover:border-hpink/40",
    title: "Logistics",
    items: ["Available for worldwide contract deployment", "Valid passport"],
  },
];

export default function Skills() {
  return (
    <section id="skills" className="relative py-24 lg:py-32" data-testid="skills-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
        <SectionHeading index="06" eyebrow="Skills & Instruments" title="The Full Toolkit" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CARDS.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.08} className="h-full">
              <div
                className={`group h-full rounded-3xl border border-white/10 bg-white/[0.04] p-7 transition-all duration-300 ${c.glow}`}
                data-testid={`skills-card-${c.id}`}
              >
                <c.icon size={22} className={`${c.accent} mb-5`} />
                <h3 className="font-display text-xl font-extrabold tracking-tight mb-4">{c.title}</h3>
                <ul className="space-y-2.5">
                  {c.items.map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-sm text-hmut leading-snug">
                      <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-current ${c.accent}`} />
                      <span className="flex items-center gap-1.5">
                        {c.id === "logistics" && item === "Valid passport" && (
                          <ShieldCheck size={13} className="text-hblue shrink-0" />
                        )}
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
